// Site-wide i18n dictionary (ES default, EN secondary).
// Used through the global LanguageContext + useT() hook.

export const SITE_STRINGS = {
  // ===== Header =====
  nav_particulares: { es: "Particulares", en: "Personal" },
  nav_empresas_top: { es: "Autónomos y Empresas", en: "Self-employed & Business" },
  nav_estudio_zona: { es: "Estudia tu zona", en: "Check your area" },
  nav_test_velocidad: { es: "Test de velocidad", en: "Speed test" },
  nav_call_us: { es: "Llámanos al", en: "Call us at" },
  nav_clients_area: { es: "Área de Clientes", en: "Customer Area" },
  nav_check_coverage: { es: "COMPROBAR COBERTURA FIBRA", en: "CHECK FIBER COVERAGE" },
  nav_check_coverage_short: { es: "COMPROBAR COBERTURA", en: "CHECK COVERAGE" },

  nav_fibra_movil: { es: "FIBRA+FIJO+MÓVIL", en: "FIBER+LANDLINE+MOBILE" },
  nav_tarifas_movil: { es: "TARIFAS MÓVIL", en: "MOBILE PLANS" },
  nav_fibra_fijo: { es: "FIBRA Y FIJO", en: "FIBER & LANDLINE" },
  nav_empresas: { es: "EMPRESAS", en: "BUSINESS" },
  nav_eventos: { es: "EVENTOS", en: "EVENTS" },
  nav_tv: { es: "TV", en: "TV" },
  nav_roaming: { es: "ROAMING", en: "ROAMING" },
  nav_travel: { es: "TRAVEL", en: "TRAVEL" },
  nav_peninsula: { es: "PENÍNSULA", en: "MAINLAND SPAIN" },
  nav_internet_rural: { es: "INTERNET RURAL", en: "RURAL INTERNET" },

  // ===== Footer =====
  footer_tagline: { es: "De Canarias, para Canarias", en: "From the Canaries, for the world" },
  footer_about: {
    es: "Operador de telecomunicaciones canario. Fibra, móvil, TV y eSIM internacional.",
    en: "Canary Islands telecom operator. Fiber, mobile, TV and international eSIM.",
  },
  footer_products: { es: "Productos", en: "Products" },
  footer_company: { es: "Empresa", en: "Company" },
  footer_legal: { es: "Legal", en: "Legal" },
  footer_contact: { es: "Contacto", en: "Contact" },
  footer_follow: { es: "Síguenos", en: "Follow us" },
  footer_about_us: { es: "Sobre nosotros", en: "About us" },
  footer_privacy: { es: "Política de privacidad", en: "Privacy policy" },
  footer_cookies: { es: "Cookies", en: "Cookies" },
  footer_terms: { es: "Condiciones de contratación", en: "Service terms" },
  footer_data_protection: { es: "Protección de datos", en: "Data protection" },
  footer_speed_legal: { es: "Información de velocidad", en: "Speed information" },
  footer_rights: { es: "Todos los derechos reservados", en: "All rights reserved" },
  footer_canarias_prices: {
    es: "Todos los precios mostrados incluyen IGIC y son válidos para clientes en Canarias.",
    en: "All listed prices include IGIC (Canary Islands VAT) and are valid for customers in the Canary Islands.",
  },
  footer_peninsula_prices: {
    es: "Todos los precios mostrados en esta página incluyen IVA (21%) y son válidos para clientes en la España peninsular.",
    en: "All prices shown on this page include VAT (21%) and are valid for customers in mainland Spain.",
  },

  // ===== Common UI =====
  cta_contract: { es: "Contratar", en: "Get this plan" },
  cta_more_info: { es: "Más información", en: "More info" },
  cta_call_now: { es: "Llamar ahora", en: "Call now" },
  cta_whatsapp: { es: "WhatsApp", en: "WhatsApp" },
  cta_check_coverage: { es: "Comprobar cobertura", en: "Check coverage" },
  cta_view_plans: { es: "Ver tarifas", en: "View plans" },
  cta_buy: { es: "Comprar", en: "Buy" },
  cta_back: { es: "Volver", en: "Back" },
  cta_continue: { es: "Continuar", en: "Continue" },

  // Pricing
  price_month: { es: "/mes", en: "/month" },
  price_iva_inc: { es: "Impuestos incluidos · Precios válidos para Canarias", en: "Taxes included · Prices valid for the Canary Islands" },
  price_from: { es: "Desde", en: "From" },

  // Section labels
  section_popular: { es: "POPULAR", en: "POPULAR" },
  section_best_seller: { es: "MÁS VENDIDA", en: "BEST SELLER" },
  section_new: { es: "NUEVO", en: "NEW" },
  section_offer: { es: "OFERTA", en: "OFFER" },

  // ===== HomePage =====
  home_hero_eyebrow: { es: "Operador canario", en: "Canary Islands operator" },
  home_hero_title_1: { es: "Internet de fibra", en: "Fiber internet" },
  home_hero_title_2: { es: "para tu hogar y tu negocio", en: "for your home and business" },
  home_hero_subtitle: {
    es: "Fibra simétrica de hasta 1 Gb, móvil sin permanencia, TV con canales premium y eSIM internacional para viajar. Todo con soporte canario en español.",
    en: "Symmetric fiber up to 1 Gb, no-commitment mobile, premium TV channels and international eSIM for travel. All with Spanish support from the Canaries.",
  },
  home_hero_cta_coverage: { es: "Comprobar cobertura", en: "Check coverage" },
  home_hero_cta_plans: { es: "Ver tarifas", en: "View plans" },

  home_section_products: { es: "Nuestros productos", en: "Our products" },
  home_product_fibra: { es: "Fibra y Fijo", en: "Fiber & Landline" },
  home_product_fibra_desc: { es: "Internet de hasta 1 Gb simétrico con llamadas ilimitadas", en: "Symmetric internet up to 1 Gb with unlimited calls" },
  home_product_movil: { es: "Tarifas Móvil", en: "Mobile Plans" },
  home_product_movil_desc: { es: "Líneas móviles sin permanencia desde 6,90 €/mes", en: "No-commitment mobile lines from €6.90/month" },
  home_product_tv: { es: "Televisión", en: "Television" },
  home_product_tv_desc: { es: "Cientos de canales en HD, deportes y plataformas premium", en: "Hundreds of HD channels, sports and premium platforms" },
  home_product_empresas: { es: "Empresas", en: "Business" },
  home_product_empresas_desc: { es: "Soluciones a medida para autónomos y empresas", en: "Tailored solutions for self-employed and businesses" },
  home_product_travel: { es: "Travel eSIM", en: "Travel eSIM" },
  home_product_travel_desc: { es: "Datos móviles en más de 180 países, activación instantánea", en: "Mobile data in 180+ countries with instant activation" },

  home_why_title: { es: "¿Por qué LiveWifi?", en: "Why LiveWifi?" },
  home_why_canarias: { es: "100% canario", en: "100% from the Canaries" },
  home_why_canarias_desc: { es: "Soporte y atención en horario canario, en español", en: "Support and service in Canary Islands hours, in Spanish" },
  home_why_no_perma: { es: "Sin permanencia", en: "No commitment" },
  home_why_no_perma_desc: { es: "Sin contratos largos ni penalizaciones por cambiar", en: "No long contracts or penalties for switching" },
  home_why_speed: { es: "Fibra hasta 1 Gb", en: "Fiber up to 1 Gb" },
  home_why_speed_desc: { es: "Velocidad simétrica real, ideal para teletrabajo y streaming", en: "Real symmetric speed, ideal for remote work and streaming" },
  home_why_24_7: { es: "Soporte 24/7", en: "24/7 support" },
  home_why_24_7_desc: { es: "Por teléfono, WhatsApp y email cuando lo necesites", en: "By phone, WhatsApp and email whenever you need" },

  // ===== FibraMovilPage / packs =====
  fm_hero_eyebrow: { es: "Pack Fibra + Móvil", en: "Fiber + Mobile pack" },
  fm_hero_title: { es: "Crea tu pack a medida", en: "Build your custom pack" },
  fm_hero_subtitle: {
    es: "Combina fibra y móvil en un solo paquete y ahorra cada mes. Sin permanencia, sin sorpresas.",
    en: "Combine fiber and mobile in a single pack and save every month. No commitment, no surprises.",
  },
  fm_promo_banner: { es: "Combina Fibra + Móvil y ahorra 2€/mes", en: "Combine Fiber + Mobile and save €2/month" },

  // ===== TarifasMovilPage =====
  tm_hero_eyebrow: { es: "Tarifas móvil", en: "Mobile plans" },
  tm_hero_title: { es: "Móvil sin permanencia", en: "Mobile, no commitment" },
  tm_hero_subtitle: {
    es: "Líneas con datos en 5G, llamadas ilimitadas y la mejor cobertura nacional.",
    en: "5G data plans, unlimited calls and the best nationwide coverage.",
  },

  // ===== FibraFijoPage =====
  ff_hero_eyebrow: { es: "Fibra y fijo", en: "Fiber & landline" },
  ff_hero_title: { es: "Fibra simétrica hasta 1 Gb", en: "Symmetric fiber up to 1 Gb" },
  ff_hero_subtitle: {
    es: "Internet ultrarrápido con fijo incluido. Instalación gratuita y soporte en Canarias.",
    en: "Ultra-fast internet with landline included. Free installation and support from the Canaries.",
  },

  // ===== EmpresasPage =====
  emp_hero_eyebrow: { es: "Para tu negocio", en: "For your business" },
  emp_hero_title: { es: "Soluciones para empresas", en: "Business solutions" },
  emp_hero_subtitle: {
    es: "Fibra dedicada, centralita virtual, telefonía IP y soporte prioritario para tu empresa.",
    en: "Dedicated fiber, virtual PBX, IP telephony and priority support for your business.",
  },

  // ===== TVPage =====
  tv_hero_eyebrow: { es: "Televisión", en: "Television" },
  tv_hero_title: { es: "TV con todos los canales", en: "TV with every channel" },
  tv_hero_subtitle: {
    es: "Cientos de canales en HD, fútbol, cine premium y plataformas digitales.",
    en: "Hundreds of HD channels, football, premium movies and digital platforms.",
  },

  // ===== RoamingPage =====
  roam_hero_eyebrow: { es: "Roaming", en: "Roaming" },
  roam_hero_title: { es: "Tu móvil contigo en cualquier país", en: "Your mobile with you in any country" },
  roam_hero_subtitle: {
    es: "Llamadas, SMS y datos en el extranjero con tarifas claras y sin sorpresas.",
    en: "Calls, SMS and data abroad with clear rates and no surprises.",
  },

  // ===== InternetRuralPage =====
  rural_hero_eyebrow: { es: "Internet rural", en: "Rural internet" },
  rural_hero_title: { es: "Internet en zonas sin fibra", en: "Internet where fiber doesn't reach" },
  rural_hero_subtitle: {
    es: "Conectamos zonas rurales con tecnología inalámbrica fiable. Cobertura en toda Canarias.",
    en: "We connect rural areas with reliable wireless technology. Coverage across the Canaries.",
  },

  // ===== ContactPage =====
  contact_hero_title: { es: "Contacto", en: "Contact" },
  contact_hero_subtitle: {
    es: "Estamos aquí para ayudarte. Contáctanos por teléfono, WhatsApp o email.",
    en: "We're here to help. Reach us by phone, WhatsApp or email.",
  },
  contact_phone: { es: "Teléfono", en: "Phone" },
  contact_email: { es: "Email", en: "Email" },
  contact_address: { es: "Dirección", en: "Address" },
  contact_hours: { es: "Horario", en: "Hours" },
  contact_form_name: { es: "Nombre", en: "Name" },
  contact_form_email: { es: "Email", en: "Email" },
  contact_form_phone: { es: "Teléfono", en: "Phone" },
  contact_form_message: { es: "Mensaje", en: "Message" },
  contact_form_send: { es: "Enviar", en: "Send" },

  // ===== Coverage / contract modals =====
  cov_title: { es: "Comprueba la cobertura de fibra", en: "Check fiber coverage" },
  cov_subtitle: { es: "Introduce tu dirección para ver si tenemos fibra en tu zona", en: "Enter your address to see if we have fiber in your area" },
  cov_address_ph: { es: "Calle, número, ciudad", en: "Street, number, city" },
  cov_check: { es: "Comprobar", en: "Check" },

  // Floating
  whatsapp_label: { es: "Habla con nosotros", en: "Chat with us" },
  cookie_msg: {
    es: "Usamos cookies para mejorar tu experiencia. Al continuar, aceptas su uso.",
    en: "We use cookies to improve your experience. By continuing, you accept their use.",
  },
  cookie_accept: { es: "Aceptar", en: "Accept" },
  cookie_more: { es: "Más información", en: "More info" },

  // Language switcher tooltip
  lang_switch_to_en: { es: "Cambiar a inglés", en: "Switch to English" },
  lang_switch_to_es: { es: "Cambiar a español", en: "Switch to Spanish" },

  // ===== HomePage extended =====
  home_eyebrow: { es: "OPERADOR CON INFRAESTRUCTURA PROPIA", en: "OPERATOR WITH OUR OWN INFRASTRUCTURE" },
  home_h1_a: { es: "El internet que", en: "The internet that" },
  home_h1_b: { es: "funciona de verdad.", en: "actually works." },
  home_h1_accent_a: { es: "Sin letra pequeña.", en: "No fine print." },
  home_h1_accent_b: { es: "Sin historias.", en: "No stories." },
  home_h1_sub: {
    es: "Operador canario con red propia. Técnicos que pisan tu municipio, atención por WhatsApp 24/7 y sin subidas de precio al cabo del año.",
    en: "Canarian operator with our own network. Technicians who know your area, 24/7 WhatsApp support, and no price hikes after the first year.",
  },
  home_btn_tarifas: { es: "Ver tarifas", en: "View plans" },
  home_btn_empresas: { es: "Empresas", en: "Business" },
  home_btn_cobertura: { es: "Cobertura", en: "Coverage" },
  home_stat_ftth_label: { es: "Red de fibra propia", en: "Our own fiber network" },
  home_stat_ftth_sub: { es: "Red propia + mayorista", en: "Own + wholesale" },
  home_stat_dc_label: { es: "Datacenter propio", en: "Our own datacenter" },
  home_stat_dc_sub: { es: "Control total", en: "Full control" },
  home_stat_70_label: { es: "Clientes en red propia", en: "Customers on own network" },
  home_stat_70_sub: { es: "Fibra + WiMAX", en: "Fiber + WiMAX" },
  home_stat_0_label: { es: "Letra pequeña", en: "Fine print" },
  home_stat_0_sub: { es: "Sin trucos", en: "No tricks" },
  home_trust_ftth: { es: "Red FTTH propia", en: "Our FTTH network" },
  home_trust_dc: { es: "Datacenter propio", en: "Our datacenter" },
  home_trust_no_print: { es: "Sin letra pequeña", en: "No fine print" },
  home_trust_islands: { es: "8 islas", en: "8 islands" },

  home_canarias_eyebrow: { es: "OPERADOR CANARIO", en: "CANARY ISLANDS OPERATOR" },
  home_canarias_h2_a: { es: "De Canarias,", en: "From the Canaries," },
  home_canarias_h2_b: { es: "para Canarias.", en: "for the Canaries." },
  home_canarias_p1: {
    es: "No somos una multinacional con un call center en la península. Somos canarios, trabajamos en Canarias y nuestra red está en Canarias. Cuando llamas, te atiende alguien que conoce tu isla, tu municipio y tus necesidades.",
    en: "We are not a multinational with a call centre on the mainland. We are from the Canaries, we work in the Canaries and our network is in the Canaries. When you call, you talk to someone who knows your island, your town and your needs.",
  },
  home_canarias_p2: {
    es: "Llevamos años invirtiendo en infraestructura propia en las islas: fibra, WiMAX, datacenter, core de red. Cada euro que pagas se queda aquí, generando empleo local y mejorando la conectividad de tu comunidad.",
    en: "We've spent years investing in our own infrastructure on the islands: fiber, WiMAX, datacenter, network core. Every euro you pay stays here, creating local jobs and improving your community's connectivity.",
  },
  home_canarias_tag1: { es: "Atención local en Canarias", en: "Local support in the Canaries" },
  home_canarias_tag2: { es: "Soporte técnico presencial", en: "On-site technical support" },
  home_canarias_tag3: { es: "Empleo local", en: "Local employment" },
  home_canarias_tag4: { es: "Red propia en las islas", en: "Our own network on the islands" },
  home_islands_title: { es: "PRESENTES EN LAS 8 ISLAS", en: "ON ALL 8 ISLANDS" },
  home_islands_total: { es: "Direcciones en nuestra base de cobertura", en: "Addresses in our coverage database" },
  home_island_studied: { es: "En estudio", en: "Under study" },


  // WiMax hero block — "Llegamos donde la fibra no llega"
  home_wimax_eyebrow: { es: "LLEGAMOS DONDE OTROS NO LLEGAN", en: "WE REACH WHERE OTHERS DON'T" },
  home_wimax_h2_a: { es: "¿Vives en medianía,", en: "Live in a rural area," },
  home_wimax_h2_b: { es: "finca o zona rural?", en: "farm or remote zone?" },
  home_wimax_h2_accent: { es: "Tenemos solución.", en: "We have a solution." },
  home_wimax_p1: {
    es: "Si la fibra no llega a tu vivienda y los operadores grandes te dicen que no hay cobertura, nuestra red WiMAX está diseñada precisamente para eso. Velocidades reales en zonas donde antes solo había móvil de mala calidad o nada.",
    en: "If fiber doesn't reach your home and the big operators say there's no coverage, our WiMAX network is designed precisely for this. Real speeds in zones that previously had poor mobile or nothing.",
  },
  home_wimax_feat1: { es: "Hasta 100 Mb reales", en: "Up to 100 Mb real-world" },
  home_wimax_feat2: { es: "Instalación en 48-72h", en: "Installed in 48-72h" },
  home_wimax_feat3: { es: "Sin permanencia", en: "No commitment" },
  home_wimax_feat4: { es: "Soporte técnico canario", en: "Canary Islands tech support" },
  home_wimax_cta: { es: "Pregúntanos por WhatsApp", en: "Ask us on WhatsApp" },
  home_wimax_cases_title: { es: "Zonas donde ya damos servicio", en: "Areas we already cover" },
  home_wimax_cases: {
    es: "Medianías de Gran Canaria · Cumbre tinerfeña · Norte de Lanzarote · Interior de Fuerteventura · Toda La Palma, La Gomera y El Hierro",
    en: "Inner Gran Canaria · Tenerife highlands · North Lanzarote · Inland Fuerteventura · All La Palma, La Gomera and El Hierro",
  },

  // Section 3 Infraestructura
  home_infra_eyebrow: { es: "LO QUE NOS HACE DIFERENTES", en: "WHAT MAKES US DIFFERENT" },
  home_infra_h2_a: { es: "Invertimos en red propia.", en: "We invest in our own network." },
  home_infra_h2_b: { es: "Y seguimos creciendo.", en: "And we keep growing." },
  home_infra_p1: {
    es: "Donde otros operadores simplemente revenden, nosotros hemos apostado por desplegar nuestra propia red. Tenemos fibra propia, core de red propio y datacenter propio. Donde aún no hemos llegado con infraestructura propia, trabajamos con operadores mayoristas para darte servicio igualmente.",
    en: "Where other operators simply resell, we've chosen to roll out our own network. We have our own fiber, our own core network and our own datacenter. Where we haven't deployed our own infrastructure yet, we work with wholesale operators to deliver service anyway.",
  },
  home_infra_p2: {
    es: "Nuestra red propia — fibra y WiMAX — ya soporta al 70% de nuestros clientes en las islas. El resto recibe servicio a través de infraestructura mayorista, pero siempre con nuestro core de red, nuestro soporte y nuestra gestión. Seas cliente de red propia o mayorista, quien te atiende somos nosotros.",
    en: "Our own network — fiber and WiMAX — already supports 70% of our customers across the islands. The rest are served through wholesale infrastructure, but always with our own core, support and management. Whether you're on our own or wholesale network, the one taking care of you is us.",
  },
  home_infra_card_ftth_t: { es: "Red FTTH propia", en: "Our FTTH network" },
  home_infra_card_ftth_d: { es: "Fibra óptica desplegada por LiveWifi en zonas crecientes de Canarias.", en: "Fiber rolled out by LiveWifi across an expanding footprint of the Canaries." },
  home_infra_card_core_t: { es: "Core de red propio", en: "Our network core" },
  home_infra_card_core_d: { es: "Todo el tráfico pasa por nuestro core. Tú eres nuestro cliente, no el de otro.", en: "All traffic flows through our core. You're our customer, not someone else's." },
  home_infra_card_dc_t: { es: "Datacenter propio", en: "Our own datacenter" },
  home_infra_card_dc_d: { es: "Equipamiento en instalaciones propias. Tus datos no pasan por terceros.", en: "Equipment in our own facilities. Your data doesn't pass through third parties." },
  home_infra_card_rural_t: { es: "Cobertura rural", en: "Rural coverage" },
  home_infra_card_rural_d: { es: "WiMAX para donde la fibra no llega. No dejamos a nadie sin conectar.", en: "WiMAX where fiber can't reach. We leave no one disconnected." },
  home_infra_zones_label: { es: "Red propia desplegada en", en: "Own network deployed in" },
  home_infra_zones_more: { es: "...y seguimos creciendo", en: "...and we keep growing" },

  // Section 4 dual entry
  home_dual_h2: { es: "¿Hogar o empresa?", en: "Home or business?" },
  home_dual_sub: { es: "Dos mundos, una infraestructura. La nuestra.", en: "Two worlds, one infrastructure. Ours." },
  home_dual_part_h: { es: "Particulares", en: "Personal" },
  home_dual_part_p: { es: "Fibra real, móvil sin trampas, TV a tu medida. Lo que contrataste es lo que pagas.", en: "Real fiber, no-tricks mobile, TV your way. What you signed up for is what you pay." },
  home_dual_part_cta: { es: "Ver todas las tarifas", en: "View all plans" },
  home_dual_emp_h: { es: "Empresas", en: "Business" },
  home_dual_emp_badge: { es: "INFRAESTRUCTURA PROPIA", en: "OUR OWN INFRASTRUCTURE" },
  home_dual_emp_p: { es: "Soluciones que un revendedor no puede darte. VPN, centralita, eventos, redes dedicadas.", en: "Solutions a reseller can't give you. VPN, PBX, events, dedicated networks." },
  home_dual_emp_cta: { es: "Ver soluciones empresariales", en: "View business solutions" },
  // Product items personal
  home_prod_p1_label: { es: "Fibra + Fijo + Móvil", en: "Fiber + Landline + Mobile" },
  home_prod_p1_price: { es: "Desde 26,90€", en: "From €26.90" },
  home_prod_p2_label: { es: "Solo Móvil", en: "Mobile only" },
  home_prod_p2_price: { es: "Desde 6,99€", en: "From €6.99" },
  home_prod_p3_label: { es: "Fibra y Fijo", en: "Fiber & landline" },
  home_prod_p3_price: { es: "Desde 23,90€", en: "From €23.90" },
  home_prod_p4_label: { es: "LiveWifi TV", en: "LiveWifi TV" },
  home_prod_p4_price: { es: "Desde 3€", en: "From €3" },
  home_prod_b1_label: { es: "Centralita Virtual", en: "Virtual PBX" },
  home_prod_b1_desc: { es: "Desde 30,90€/mes", en: "From €30.90/mo" },
  home_prod_b2_label: { es: "VPN Empresarial", en: "Business VPN" },
  home_prod_b2_desc: { es: "Conexiones cifradas punto a punto", en: "Encrypted site-to-site links" },
  home_prod_b3_label: { es: "Eventos y Conectividad Temporal", en: "Events & temporary connectivity" },
  home_prod_b3_desc: { es: "Despliegue en 24-48h", en: "Deploy in 24-48h" },
  home_prod_b4_label: { es: "Redes Dedicadas", en: "Dedicated networks" },
  home_prod_b4_desc: { es: "SLA 99.9% garantizado", en: "Guaranteed 99.9% SLA" },
  home_prod_b5_label: { es: "Videovigilancia IP", en: "IP video surveillance" },
  home_prod_b5_desc: { es: "Cámaras + analítica IA", en: "Cameras + AI analytics" },

  // Section 5 featured plans
  home_plans_h2_a: { es: "Lo que ves es lo que pagas.", en: "What you see is what you pay." },
  home_plans_h2_b: { es: "Punto.", en: "Period." },
  home_plans_sub: {
    es: "Tarifa válida para nuevas contrataciones, sin subidas a los 3 meses. Sin asteriscos. Sin sorpresas en la factura.",
    en: "Valid for new contracts, no price hikes after 3 months. No asterisks. No bill surprises.",
  },
  home_plans_card1_eyebrow: { es: "FIBRA + FIJO + MOVIL", en: "FIBER + LANDLINE + MOBILE" },
  home_plans_card1_title: { es: "600Mb + 120Gb", en: "600Mb + 120GB" },
  home_plans_card2_badge: { es: "LA MÁS VENDIDA", en: "BEST SELLER" },
  home_plans_card2_title: { es: "1Gb + 120Gb", en: "1Gb + 120GB" },
  home_plans_card3_eyebrow: { es: "SOLO MOVIL", en: "MOBILE ONLY" },
  home_plans_card3_title: { es: "100Gb + Ilimitadas", en: "100GB + Unlimited" },
  home_plans_per_month: { es: "€/mes", en: "€/mo" },
  home_plans_feat_fiber: { es: "Fibra", en: "Fiber" },
  home_plans_feat_fixed_inc: { es: "incluido", en: "included" },
  home_plans_feat_mobile: { es: "Móvil", en: "Mobile" },
  home_plans_feat_unlimited: { es: "ilimitadas", en: "unlimited" },
  home_plans_feat_no_perma: { es: "Sin permanencia en móvil", en: "No mobile commitment" },
  home_plans_feat_no_perma_short: { es: "Sin permanencia", en: "No commitment" },
  home_plans_feat_calls_unlim: { es: "Llamadas", en: "Calls" },
  home_plans_feat_data: { es: "datos", en: "data" },
  home_plans_btn_want: { es: "LA QUIERO", en: "GET THIS" },
  home_plans_link_all: { es: "Ver todas las tarifas", en: "View all plans" },
  home_plans_disclaimer: { es: "* Tarifa válida para nuevas contrataciones.", en: "* Pricing valid for new contracts." },

  // Section 6 events
  home_ev_eyebrow: { es: "SOLO UN OPERADOR CON RED PROPIA PUEDE HACER ESTO", en: "ONLY AN OPERATOR WITH ITS OWN NETWORK CAN DO THIS" },
  home_ev_h2_a: { es: "Conectividad", en: "Connectivity" },
  home_ev_h2_b: { es: "para", en: "for" },
  home_ev_h2_c: { es: "eventos.", en: "events." },
  home_ev_p1: {
    es: "Conciertos, festivales, ferias, congresos, competiciones deportivas, eventos corporativos y conexiones circunstanciales. Desplegamos infraestructura de red temporal con fibra, WiMAX o conexión satélite con transponder dedicado. En 24-48 horas tienes WiFi profesional para cientos de personas.",
    en: "Concerts, festivals, fairs, conferences, sports events, corporate events and short-term setups. We deploy temporary network infrastructure using fiber, WiMAX or satellite with a dedicated transponder. In 24-48 hours you have professional WiFi for hundreds of people.",
  },
  home_ev_p2: {
    es: "Esto no lo puede hacer un revendedor. Necesitas un operador que controle su propia red. Nosotros lo somos.",
    en: "A reseller can't do this. You need an operator that controls its own network. We are.",
  },
  home_ev_btn_info: { es: "Solicitar información", en: "Request information" },
  home_ev_card1_t: { es: "24-48 horas", en: "24-48 hours" },
  home_ev_card1_d: { es: "Despliegue completo", en: "Full deployment" },
  home_ev_card2_t: { es: "+200 dispositivos", en: "200+ devices" },
  home_ev_card2_d: { es: "Conectados simultáneamente", en: "Simultaneously connected" },
  home_ev_card3_t: { es: "Hasta 1Gb", en: "Up to 1Gb" },
  home_ev_card3_d: { es: "Dedicado para tu evento", en: "Dedicated to your event" },
  home_ev_card4_t: { es: "Técnico in situ", en: "On-site technician" },
  home_ev_card4_d: { es: "Soporte durante el evento", en: "Support during the event" },

  // Section 7 ADN
  home_adn_h2: { es: "Así trabajamos.", en: "How we work." },
  home_adn_sub: { es: "Sin rodeos. Sin filtros. Sin departamento de excusas.", en: "No spin. No filters. No excuses department." },
  home_adn_c1_t: { es: "Lo que ves es lo que pagas", en: "What you see is what you pay" },
  home_adn_c1_d: { es: "Tarifa válida para nuevas contrataciones. Sin subidas a los 3 meses. Sin asteriscos que te lleven a una nota a pie de página que nadie lee. Tarifas móviles y combinados sin permanencia. Fibra y fijo: 12 meses, como todo el mundo, pero te lo decimos a la cara.", en: "Valid for new contracts. No price hikes after 3 months. No asterisks that lead to footnotes nobody reads. Mobile plans and bundles with no commitment. Fiber and landline: 12 months, like everyone else, but we tell you up front." },
  home_adn_c2_t: { es: "Llamas y te cogen personas", en: "When you call, real people answer" },
  home_adn_c2_d: { es: "828 182 100. Descuelga alguien de aquí. No un robot, no un menú de 8 opciones, no una espera de 40 minutos escuchando música. Si hay un problema, lo sabemos y lo arreglamos.", en: "828 182 100. Picked up by someone from here. No bot, no 8-option menu, no 40-minute hold music. If there's a problem, we know about it and fix it." },
  home_adn_c3_t: { es: "Nuestra fibra, nuestra apuesta", en: "Our fiber, our bet" },
  home_adn_c3_d: { es: "Donde hemos desplegado red propia, controlamos cada tramo. Donde aún no llegamos con fibra propia, usamos infraestructura mayorista, pero siempre con nuestro core, nuestro soporte y nuestra gestión. Si algo falla, somos nosotros los que damos la cara.", en: "Where we've rolled out our own network, we control every segment. Where we haven't yet, we use wholesale infrastructure but always with our own core, support and management. If something breaks, we're the ones answering for it." },
  home_adn_c4_t: { es: "Nacidos en Gran Canaria", en: "Born in Gran Canaria" },
  home_adn_c4_d: { es: "Tu vecino puede ser nuestro técnico. Conocemos las medianías, los barrancos, las urbanizaciones que los grandes operadores ni saben que existen. Y si no llegamos hoy, estudiamos cómo llegar mañana.", en: "Your neighbour might be our technician. We know the highlands, the ravines, the residential areas the big operators don't even know exist. And if we can't reach you today, we study how to reach you tomorrow." },

  // Section 8 estudio zona
  home_estudio_eyebrow: { es: "¿SIN COBERTURA?", en: "NO COVERAGE?" },
  home_estudio_h2_a: { es: "¿No te llega la fibra?", en: "Fiber doesn't reach you?" },
  home_estudio_h2_b: { es: "Estudiamos tu zona.", en: "We'll study your area." },
  home_estudio_p: { es: "Dinos dónde estás y analizamos si podemos llevar fibra a tu zona. Sin compromiso, sin coste.", en: "Tell us where you are and we'll see if we can bring fiber to your area. No commitment, no cost." },
  home_estudio_btn: { es: "Ayúdanos a seguir creciendo", en: "Help us keep growing" },

  // Section 9 testimonials
  home_test_eyebrow: { es: "RESEÑAS DE GOOGLE", en: "GOOGLE REVIEWS" },
  home_test_h2: { es: "Lo que dicen nuestros clientes.", en: "What our customers say." },
  home_test_sub: { es: "Reseñas reales de Google. Sin filtrar.", en: "Real Google reviews. Unfiltered." },
  home_test_link: { es: "Ver todas las reseñas en Google", en: "View all Google reviews" },
  home_test_t_2m: { es: "Hace 2 meses", en: "2 months ago" },
  home_test_t_3m: { es: "Hace 3 meses", en: "3 months ago" },
  home_test_t_4m: { es: "Hace 4 meses", en: "4 months ago" },
  home_test_t_1m: { es: "Hace 1 mes", en: "1 month ago" },
  home_test_t_5m: { es: "Hace 5 meses", en: "5 months ago" },

  // Section 10 final CTA
  home_cta_h2: { es: "¿Hablamos?", en: "Let's talk." },
  home_cta_sub: { es: "Te asesoramos sin compromiso. En serio, sin compromiso.", en: "Free advice with no commitment. Seriously, no commitment." },
  home_cta_hours: { es: "L-V de 9:00 a 13:00 y 15:00 a 19:00 · S de 9:00 a 13:00 · Domingo cerrado", en: "Mon-Fri 9-13 & 15-19 · Sat 9-13 · Sun closed" },

  // ===== TravelLaunchPage =====
  tl_eyebrow: { es: "Lanzamiento oficial", en: "Official launch" },
  tl_h1_a: { es: "El primer", en: "The first" },
  tl_h1_b: { es: "operador canario", en: "Canary Islands operator" },
  tl_h1_c: { es: "con eSIM internacional", en: "with an international eSIM" },
  tl_sub: {
    es: "Compra tu eSIM en Canarias, úsala en 180 países. Sin permanencia, sin sorpresas.",
    en: "Buy your eSIM in the Canaries, use it in 180 countries. No commitment, no surprises.",
  },
  tl_promo_label: { es: "Código de lanzamiento:", en: "Launch code:" },
  tl_copied: { es: "Copiado", en: "Copied" },
  tl_copy: { es: "Copiar", en: "Copy" },
  tl_cta_buy: { es: "Comprar mi eSIM", en: "Buy my eSIM" },
  tl_cta_share: { es: "Compartir", en: "Share" },
  tl_countdown_label: { es: "Promoción finaliza en", en: "Promo ends in" },
  tl_countdown_days: { es: "Días", en: "Days" },
  tl_countdown_hours: { es: "Horas", en: "Hours" },
  tl_countdown_mins: { es: "Min", en: "Min" },
  tl_countdown_secs: { es: "Seg", en: "Sec" },

  tl_why_eyebrow: { es: "Por qué LiveWifi Travel", en: "Why LiveWifi Travel" },
  tl_why_h2_a: { es: "No somos otra eSIM más.", en: "We're not just another eSIM." },
  tl_why_h2_b: { es: "Somos canarios.", en: "We're from the Canaries." },
  tl_why_card1_t: { es: "Hecho en Canarias", en: "Made in the Canaries" },
  tl_why_card1_d: { es: "Desde nuestras oficinas en Telde. Soporte en español y en horario canario, no peninsular.", en: "From our offices in Telde. Support in Spanish, on Canary Islands hours — not mainland time." },
  tl_why_card1_tag: { es: "ÚNICOS", en: "UNIQUE" },
  tl_why_card2_t: { es: "180+ países cubiertos", en: "180+ countries covered" },
  tl_why_card2_d: { es: "De Europa a Japón, EEUU, América Latina, África. Misma eSIM, mismo precio en cualquier viaje.", en: "From Europe to Japan, USA, Latin America, Africa. Same eSIM, same price for any trip." },
  tl_why_card2_tag: { es: "GLOBAL", en: "GLOBAL" },
  tl_why_card3_t: { es: "Sin permanencia ni sorpresas", en: "No commitment, no surprises" },
  tl_why_card3_d: { es: "Pagas una sola vez. Sin recibos mensuales, sin cargos ocultos, sin contratos.", en: "Pay once. No monthly bills, no hidden fees, no contracts." },
  tl_why_card3_tag: { es: "TRANSPARENTE", en: "TRANSPARENT" },
  tl_why_card4_t: { es: "Operador canario regulado", en: "Regulated Canary operator" },
  tl_why_card4_d: { es: "Inscritos como operador de telecomunicaciones en España. Sin intermediarios, soporte directo desde Telde, Gran Canaria.", en: "Registered telecom operator in Spain. No middlemen, direct support from Telde, Gran Canaria." },
  tl_why_card4_tag: { es: "PRO", en: "PRO" },
  tl_why_card5_t: { es: "Activación al instante", en: "Instant activation" },
  tl_why_card5_d: { es: "QR en tu email en menos de 60 segundos. Instalación directa en iPhone y Android con un toque.", en: "QR in your inbox in under 60 seconds. One-tap install on iPhone and Android." },
  tl_why_card5_tag: { es: "INMEDIATO", en: "INSTANT" },
  tl_why_card6_t: { es: "Soporte 24/7 en español", en: "24/7 support in Spanish" },
  tl_why_card6_d: { es: "WhatsApp directo desde el primer día del viaje. Te resolvemos en minutos, no en horas.", en: "Direct WhatsApp from day one of your trip. Sorted in minutes, not hours." },
  tl_why_card6_tag: { es: "REAL", en: "REAL" },

  tl_compare_eyebrow: { es: "vs. competencia", en: "vs. competition" },
  tl_compare_h2: { es: "Comparativa real", en: "Real comparison" },
  tl_compare_sub: { es: "Precios verificados en febrero 2026", en: "Prices verified February 2026" },
  tl_compare_col_plan: { es: "Plan", en: "Plan" },
  tl_compare_disclaimer: { es: "Datos a 28 febrero 2026. Saily, Airalo y Holafly son marcas registradas de sus respectivos propietarios.", en: "Data as of 28 February 2026. Saily, Airalo and Holafly are trademarks of their respective owners." },

  tl_pride_h2_a: { es: "De Maspalomas al mundo.", en: "From Maspalomas to the world." },
  tl_pride_h2_b: { es: "Con orgullo canario.", en: "With Canary Islands pride." },
  tl_pride_p: {
    es: "Llevamos años llevando fibra y móvil a hogares de Las Palmas, Telde y Vega de San Mateo. Ahora llevamos Canarias contigo, allá donde vayas.",
    en: "We've been bringing fiber and mobile to homes in Las Palmas, Telde and Vega de San Mateo for years. Now we take the Canaries with you, wherever you go.",
  },
  tl_pride_s1: { es: "operando en Canarias", en: "operating in the Canaries" },
  tl_pride_s2: { es: "países con cobertura", en: "countries covered" },
  tl_pride_s3: { es: "soporte en español", en: "Spanish support" },
  tl_pride_s4: { es: "permanencia móvil", en: "mobile commitment" },
  tl_pride_s1_n: { es: "8 años", en: "8 years" },

  tl_final_h2_a: { es: "¿Listo para viajar", en: "Ready to travel" },
  tl_final_h2_b: { es: "conectado de verdad?", en: "really connected?" },
  tl_final_p_a: { es: "Usa", en: "Use" },
  tl_final_p_b: { es: "al pagar y llévate", en: "at checkout and get" },
  tl_final_p_c: { es: "15% de descuento", en: "15% off" },
  tl_final_p_d: { es: "en tu primer plan Travel.", en: "your first Travel plan." },
  tl_final_btn: { es: "Activar mi eSIM ahora", en: "Activate my eSIM now" },
  tl_final_chk1: { es: "Activación inmediata", en: "Instant activation" },
  tl_final_chk2: { es: "Pago seguro Redsys", en: "Secure Redsys payment" },
  tl_final_chk3: { es: "Soporte 24/7", en: "24/7 support" },

  // Misc
  back: { es: "Volver", en: "Back" },
  loading: { es: "Cargando...", en: "Loading..." },

  // Cookie banner
  cookie_title: { es: "Usamos cookies", en: "We use cookies" },
  cookie_text: {
    es: "Utilizamos cookies propias y de terceros para mejorar tu experiencia de navegación, analizar el tráfico del sitio y personalizar contenido. Puedes aceptar todas o solo las esenciales. Más información en nuestra",
    en: "We use first- and third-party cookies to improve your browsing experience, analyse site traffic and personalise content. You can accept all or only essential cookies. More info in our",
  },
  cookie_policy: { es: "política de cookies", en: "cookie policy" },
  cookie_accept_all: { es: "Aceptar todas", en: "Accept all" },
  cookie_only_essential: { es: "Solo esenciales", en: "Essential only" },

  // ===== Commercial sections (Fibra/Movil/TV/Empresas/Roaming/Rural/Contact) =====
  sec_la_quiero: { es: "LA QUIERO", en: "GET THIS" },
  sec_popular: { es: "POPULAR", en: "POPULAR" },
  sec_best_seller: { es: "MÁS VENDIDA", en: "BEST SELLER" },
  sec_recommended: { es: "RECOMENDADA", en: "RECOMMENDED" },
  sec_promo_label: { es: "Promoción", en: "Promotion" },
  sec_promo_until: { es: "Válida hasta el 30 de junio", en: "Valid until 30 June" },
  sec_unlimited_calls: { es: "Llamadas ilimitadas", en: "Unlimited calls" },
  sec_wifi_calls: { es: "Llamadas WiFi (VoWiFi)", en: "WiFi calling (VoWiFi)" },
  sec_no_commitment: { es: "Sin permanencia", en: "No commitment" },
  sec_fiber_included: { es: "Fibra", en: "Fiber" },
  sec_fixed_included: { es: "Fijo incluido", en: "Landline included" },
  sec_mobile: { es: "Móvil", en: "Mobile" },
  sec_5g_volte: { es: "5G + VoLTE", en: "5G + VoLTE" },
  sec_rollover_data: { es: "acumulables", en: "rollover" },
  sec_to_fixed: { es: "a fijos", en: "to landlines" },
  sec_to_mobile: { es: "a móviles", en: "to mobiles" },
  sec_router_included: { es: "Router WiFi incluido", en: "WiFi router included" },
  sec_commitment_12m: { es: "12 meses de permanencia", en: "12-month commitment" },
  sec_bonus_calls: { es: "Llamadas ilimitadas desde fijo", en: "Unlimited calls from landline" },
  sec_bonus_unlimited: { es: "A fijos y móviles", en: "To landlines & mobiles" },

  // FibraMovilSection extras
  fm_title_a: { es: "Tarifas", en: "Plans" },
  fm_title_b: { es: "Fibra + Fijo + Móvil", en: "Fiber + Landline + Mobile" },
  fm_subtitle: { es: "Combina tu fibra, fijo y móvil en un solo pack. Llamadas ilimitadas incluidas.", en: "Combine your fiber, landline and mobile in a single pack. Unlimited calls included." },
  fm_promo_pill: { es: "-2€ PROMO", en: "-€2 PROMO" },
  fm_promo_legal: { es: "Precio promocional válido solo para nuevos clientes en alta. Aplicable a la primera contratación de fibra+móvil. Sujeto a permanencia de 12 meses en la línea fija. Sin permanencia en línea móvil.", en: "Promotional price only for new customers signing up. Applies to first fiber+mobile contract. 12-month commitment on the landline. No commitment on the mobile line." },
  fm_promo_legal_short: { es: "Promo para nuevos clientes en alta", en: "Promo for new customers only" },
  promo_see_full: { es: "Ver condiciones completas →", en: "See full terms →" },
  ff_promo_legal: { es: "Promoción válida para nuevos clientes en alta. Aplicable únicamente a la primera contratación de fibra y/o fijo. Permanencia de 12 meses. Precios con IGIC incluido.", en: "Promotion valid for new customers only. Applies to the first fiber and/or landline contract. 12-month commitment. Prices include IGIC (Canary VAT)." },
  ff_promo_legal_peninsula: { es: "Promoción válida para nuevos clientes en alta. Aplicable únicamente a la primera contratación de fibra y/o fijo. Permanencia de 12 meses. Precios con IVA (21%) incluido.", en: "Promotion valid for new customers only. Applies to the first fiber and/or landline contract. 12-month commitment. Prices include VAT (21%)." },
  tm_promo_legal: { es: "Promoción válida para nuevos clientes en alta. Aplicable únicamente a la primera contratación móvil. Tarifas móviles sin permanencia. Precios con IGIC incluido.", en: "Promotion valid for new customers only. Applies to the first mobile contract. Mobile plans have no commitment. Prices include IGIC (Canary VAT)." },
  tm_promo_legal_peninsula: { es: "Promoción válida para nuevos clientes en alta. Aplicable únicamente a la primera contratación móvil. Tarifas móviles sin permanencia. Precios con IVA (21%) incluido.", en: "Promotion valid for new customers only. Applies to the first mobile contract. Mobile plans have no commitment. Prices include VAT (21%)." },
  promo_legal_label: { es: "Promoción válida para nuevos clientes en alta.", en: "Promotion valid for new customers only." },
  fm_cat: { es: "FIBRA + FIJO + MÓVIL", en: "FIBER + LANDLINE + MOBILE" },
  fm_extra_lines: { es: "Añade líneas adicionales desde", en: "Add extra lines from" },

  // TarifasMovilSection extras
  tm_title_a: { es: "Nuestras", en: "Our" },
  tm_title_b: { es: "tarifas móvil", en: "mobile plans" },
  tm_subtitle: { es: "Llamadas ilimitadas y los mejores precios", en: "Unlimited calls and the best prices" },
  tm_feat_triple: { es: "Triple cobertura", en: "Triple coverage" },
  tm_feat_5g: { es: "5G incluido", en: "5G included" },
  tm_feat_volte: { es: "VoLTE", en: "VoLTE" },
  tm_feat_vowifi: { es: "Llamadas WiFi", en: "WiFi calling" },
  tm_feat_rollover: { es: "Datos acumulables", en: "Rollover data" },
  tm_cat: { es: "MÓVIL", en: "MOBILE" },
  tm_travel_teaser_text: { es: "eSIM de viaje para más de 190 países. Habla y navega como en casa. Sin acuerdos de roaming, sin sorpresas.", en: "Travel eSIM for 190+ countries. Talk and surf like at home. No roaming agreements, no surprises." },
  tm_travel_cta: { es: "Ver planes desde 9,90€", en: "View plans from €9.90" },

  // FibraFijoSection extras
  ff_title_a: { es: "Tarifas de", en: "Plans for" },
  ff_title_b: { es: "Fibra y Fijo", en: "Fiber & Landline" },
  ff_subtitle: { es: "Solo para tu casa, sin línea móvil", en: "Just for your home, no mobile line" },
  ff_cat: { es: "FIBRA Y FIJO", en: "FIBER & LANDLINE" },

  // ContactSection
  cs_title_a: { es: "CONTACTA", en: "GET IN" },
  cs_title_b: { es: "CON NOSOTROS", en: "TOUCH" },
  cs_subtitle: { es: "Si necesitas ayuda para contratar, nuestros asesores te ayudarán", en: "If you need help to subscribe, our advisors will help you" },
  cs_call_label: { es: "Llámanos", en: "Call us" },
  cs_form_title: { es: "Te llamamos gratis", en: "We'll call you free" },
  cs_form_name: { es: "Tu nombre", en: "Your name" },
  cs_form_phone: { es: "Teléfono", en: "Phone" },
  cs_form_email: { es: "Email", en: "Email" },
  cs_service_fm: { es: "Fibra y Móvil", en: "Fiber & Mobile" },
  cs_service_ff: { es: "Fibra y Fijo", en: "Fiber & Landline" },
  cs_service_sm: { es: "Solo Móvil", en: "Mobile only" },
  cs_service_emp: { es: "Empresas", en: "Business" },
  cs_form_send: { es: "TE LLAMAMOS", en: "CALL ME BACK" },
  cs_form_sending: { es: "Enviando...", en: "Sending..." },
  cs_form_success_t: { es: "¡Mensaje Enviado!", en: "Message sent!" },
  cs_form_success_p: { es: "Te contactaremos pronto.", en: "We'll be in touch soon." },
  cs_form_hours: { es: "Horario: L-V de 9:00 a 13:00 y 15:00 a 19:00 · S de 9:00 a 13:00 · Domingo cerrado", en: "Hours: Mon-Fri 9-13 & 15-19 · Sat 9-13 · Sun closed" },
  cs_form_error: { es: "Error al enviar. Inténtalo de nuevo.", en: "Send failed. Please try again." },

  // WimaxRuralSection
  rural_eyebrow: { es: "INTERNET PARA ZONAS RURALES", en: "INTERNET FOR RURAL AREAS" },
  rural_title_a: { es: "¿Sin fibra?", en: "No fiber?" },
  rural_title_b: { es: "Tenemos WiMAX", en: "We've got WiMAX" },
  rural_subtitle: { es: "Internet inalámbrico de alta velocidad que llega donde el cable no puede.", en: "High-speed wireless internet where cable can't reach." },
  rural_how_title: { es: "¿Cómo funciona el WiMAX?", en: "How does WiMAX work?" },
  rural_step1_t: { es: "Señal inalámbrica de largo alcance", en: "Long-range wireless signal" },
  rural_step1_d: { es: "Antenas de alta ganancia que envían la señal desde nuestras torres hasta tu tejado o fachada.", en: "High-gain antennas that beam signal from our towers to your roof or façade." },
  rural_step2_t: { es: "Velocidades de hasta 100 Mbps", en: "Speeds up to 100 Mbps" },
  rural_step2_d: { es: "Suficiente para streaming, videollamadas, teletrabajo y toda la familia conectada.", en: "Enough for streaming, video calls, remote work and the whole family online." },
  rural_step3_t: { es: "Instalación rápida, sin obras", en: "Quick install, no construction" },
  rural_step3_d: { es: "No hace falta abrir zanjas. Un técnico instala la antena y en pocas horas ya tienes Internet.", en: "No trenching needed. A technician installs the antenna and within hours you have internet." },
  rural_coverage_ask: { es: "¿Quieres saber si tenemos cobertura WiMAX?", en: "Want to know if you have WiMAX coverage?" },
  rural_coverage_help: { es: "Envíanos tu ubicación por WhatsApp al 601 651 014 y te lo confirmamos en minutos.", en: "Send us your location on WhatsApp at 601 651 014 and we'll confirm in minutes." },
  rural_badge: { es: "INTERNET RURAL", en: "RURAL INTERNET" },
  rural_plan_title: { es: "Hasta 100 Mb", en: "Up to 100 Mb" },
  rural_plan_subtitle: { es: "La velocidad de la fibra, de forma inalámbrica", en: "Fiber-like speed, wireless" },
  rural_from: { es: "desde", en: "from" },
  rural_feat1: { es: "Hasta 100 Mbps de bajada", en: "Up to 100 Mbps download" },
  rural_feat2: { es: "Instalación incluida", en: "Installation included" },
  rural_feat3: { es: "Router WiFi incluido", en: "WiFi router included" },
  rural_feat4: { es: "Sin obras ni cables", en: "No works, no cables" },
  rural_warning: { es: "Velocidad supeditada a disponibilidad en la zona", en: "Speed subject to area availability" },
  rural_cta: { es: "SOLICITA TU ESTUDIO DE ZONA GRATIS", en: "REQUEST YOUR FREE AREA STUDY" },
  rural_cta_sub: { es: "Sin compromiso — Te contactamos en 24h", en: "No commitment — We'll contact you in 24h" },

  // ===== Travel auto-promo welcome popup =====
  tap_title: { es: "¡15% de descuento aplicado!", en: "15% discount applied!" },
  tap_body: { es: "Hemos activado el código", en: "We've activated the code" },
  tap_body_2: { es: "Tu primer plan Travel cuesta un 15% menos.", en: "Your first Travel plan costs 15% less." },
  tap_cta: { es: "Ver planes", en: "View plans" },
  tap_dismiss: { es: "Entendido", en: "Got it" },
  tap_expires_in: { es: "Expira en", en: "Expires in" },
  tap_days: { es: "días", en: "days" },
  tap_day: { es: "día", en: "day" },
  tap_hours: { es: "horas", en: "hours" },
  tap_hour: { es: "hora", en: "hour" },
  tap_today: { es: "¡Último día!", en: "Last day!" },
  tap_urgency_low: { es: "Sin compromiso. Solo se aplica al primer pedido.", en: "No commitment. Applies to your first order only." },
};

export const t = (key, lang) => {
  const e = SITE_STRINGS[key];
  if (!e) return key;
  return e[lang] || e.es || key;
};

export default SITE_STRINGS;
